/* ===========================================================================
   Releasit COD — limpieza de altura en el propio formulario
   ---------------------------------------------------------------------------
   Campos del form Releasit:
     #_rsi-field-address       (Calle)  -> Shopify address1   = nombre de la calle
     #_rsi-field-civic_number  (Altura) -> Shopify address2   = altura (solo número)
     #_rsi-field-company       (Empresa)-> Shopify company    = piso/depto
   ACTIVAR el campo "Company" en el panel de Releasit (lo usamos como Piso/Depto;
   el script le cambia el label y el placeholder solo).

   Qué hace:
   - Reescribe los textos de los campos (UX).
   - Al salir de Calle o Altura, redistribuye: saca el número que el cliente metió
     en Calle, deja la altura limpia en Altura y el piso/depto en el campo Empresa.
   - Si no encuentra altura, avisa y bloquea el botón COMPRAR.

   PEGAR este script en: Releasit > código personalizado (o un snippet del tema
   que cargue en la página del checkout).
   =========================================================================== */
(function () {
  'use strict';

  /* ===================== CONFIG (ajustá si hace falta) ===================== */
  const ID_CALLE   = '_rsi-field-address';        // -> address1
  const ID_ALTURA  = '_rsi-field-civic_number';   // -> address2 (altura)
  const ID_PISO    = '_rsi-field-company';         // -> company built-in (fallback)
  // En esta tienda el "Piso/Depto" es un campo CUSTOM de Releasit (additional field):
  //   name="additionals_text_input_company_field"  id="_rsi-field-additionals_text_input.<dinámico>"
  // Por eso lo resolvemos por NAME (estable), no por id.
  const PISO_NAME  = 'additionals_text_input_company_field';
  // Botones finales del modal Releasit (confirmados por DOM):
  //   COD     -> button._rsi-modal-submit-button          ("PAGAR CONTRA ENTREGA")
  //   Tarjeta -> a._rsi-buy-now-custom-additionals-button ("PAGAR AHORA")
  const SEL_SUBMIT = '._rsi-modal-submit-button, ._rsi-buy-now-custom-additionals-button';

  /* ===================== PARSER (idéntico al .js) ===================== */
  const TIPOS_CALLE = /^(?:calle|avenida|avda|av|diagonal|diag|dg|pasaje|pasje|psje|pje|ruta|rn|rp|bulevar|boulevard|blvd|bvar|bv|autopista|autop|colectora|colec|camino|cno)\.?$/i;
  const PISO_RE = /\b(?:pb|planta\s+baja|(?:piso|p|dpto|depto|dto|departamento|depart\w*|local|loc|puerta|pta|of|ofic\w*|oficina|interno|int|torre|block|casa|lote|mz|manzana)\.?\s*[º°#:.\-]?\s*(?:\d+|[a-z]\b))/i;
  const norm = (s) => String(s == null ? '' : s).replace(/\s+/g, ' ').trim();
  const soloDigitos = (s) => (String(s).match(/\d+/) || [''])[0];
  const bordes = (s) => String(s).replace(/^[\s,;.\-]+|[\s,;.\-]+$/g, '').trim();
  function splitPiso(s){ const m=s.match(PISO_RE); if(!m) return [s,'']; return [bordes(s.slice(0,m.index)), bordes(s.slice(m.index))]; }
  function sinTipo(s){ const w=s.split(/\s+/).filter(Boolean); while(w.length&&TIPOS_CALLE.test(w[0])) w.shift(); return w.join(' '); }
  function alturaDeCalle(base){ const m=base.match(/^(.*?)[\s,]+(\d+)\s*(bis)?\s*$/i); if(!m) return null; const previo=bordes(m[1]); if(sinTipo(previo)==='') return null; return {calle:previo,altura:m[2],bis:!!m[3]}; }
  function alturaDeAltura(base){ const m=base.match(/^(\d+)\s*(bis)?\s*[,\-]?\s*(.*)$/i); if(!m) return null; return {altura:m[1],bis:!!m[2],resto:bordes(m[3])}; }
  function extraerEnvioAR(calleRaw, alturaRaw){
    const calle=norm(calleRaw), altura=norm(alturaRaw);
    const out={calle,altura:'',pisoDepto:'',bis:false,observacion:'',revisar:false,origenAltura:''};
    if(/\bs\/?\s*n[º°.]?\b/i.test(calle+' '+altura)){ out.observacion='sin numero (s/n)'; out.revisar=true; }
    const [calleBase,pisoCalle]=splitPiso(calle);
    const [alturaBase,pisoAltura]=splitPiso(altura);
    const aC=alturaDeCalle(calleBase); let bis=false;
    if(aC){
      out.calle=aC.calle; out.altura=aC.altura; bis=aC.bis; out.origenAltura='calle';
      let restoAlt=altura;
      if(alturaBase && soloDigitos(alturaBase)===aC.altura){ restoAlt=[alturaBase.replace(/^\s*\d+\s*/,''),pisoAltura].join(' '); }
      out.pisoDepto=bordes([pisoCalle,restoAlt].filter(Boolean).join(' '));
      const nAlt=soloDigitos(alturaBase);
      if(nAlt && nAlt.length>=3 && nAlt!==aC.altura) out.revisar=true;
    } else {
      const aA=alturaDeAltura(alturaBase);
      if(aA){ out.calle=calleBase; out.altura=aA.altura; bis=aA.bis; out.origenAltura='altura'; out.pisoDepto=bordes([aA.resto,pisoAltura,pisoCalle].filter(Boolean).join(' ')); }
      else { out.calle=calleBase; out.pisoDepto=bordes([pisoCalle,pisoAltura].filter(Boolean).join(' ')); out.revisar=true; }
    }
    out.altura=soloDigitos(out.altura); out.bis=bis;
    if(bis) out.observacion=bordes(`${out.observacion} altura ${out.altura} bis`);
    if(!out.calle || !out.altura) out.revisar=true;
    return out;
  }
  function aDireccionShopify(calle, altura){
    const r=extraerEnvioAR(calle, altura);
    let company=r.pisoDepto;
    if(r.bis) company=bordes(company+' (alt. bis)');
    return { address1:r.calle, address2:r.altura, company:company, alturaNumerica:r.altura, revisar:r.revisar, origenAltura:r.origenAltura };
  }

  /* ===================== DOM helpers ===================== */
  const F = (id) => document.getElementById(id);
  const item = (el) => (el ? el.closest('._rsi-modal-fields-item') : null);
  // resuelve el campo Piso/Depto por NAME (id dinámico), con fallback al Company built-in
  function getPiso(){
    return document.querySelector('#_rsi-cod-form-modal-form [name="' + PISO_NAME + '"]')
        || document.querySelector('[name="' + PISO_NAME + '"]')
        || F(ID_PISO);
  }
  function setVal(el, v){
    if(el && el.value !== v){
      el.value = v;
      el.dispatchEvent(new Event('input',  { bubbles:true }));
      el.dispatchEvent(new Event('change', { bubbles:true }));
    }
  }
  function setLabel(el, text, req){
    const it = item(el); if(!it) return;
    const lab = it.querySelector('label'); if(!lab) return;
    lab.innerHTML = text + (req ? ' <span class="_rsi-modal-required-label">*</span>' : '');
  }
  // UX: textos de los campos (idempotente, re-aplica si el modal se vuelve a montar)
  // El campo "Company" (Piso/Depto) se OCULTA visualmente pero se mantiene en el DOM:
  // el script lo rellena solo y Releasit lo envía igual al pedido (Shopify "company").
  function setTexto(){
    const c=F(ID_CALLE), a=F(ID_ALTURA), p=getPiso();
    if(c && !c.dataset.altReady){ c.placeholder='Ej: Av. Maipú'; setLabel(c,'Calle',true); c.dataset.altReady='1'; }
    if(a && !a.dataset.altReady){ a.placeholder='Ej: 1840 Piso 3 Depto A'; setLabel(a,'Altura',true); a.dataset.altReady='1'; }
    if(p && !p.dataset.altReady){
      const it=item(p);
      if(it) it.style.setProperty('display','none','important'); // oculto, pero sigue activo y enviándose
      p.dataset.altReady='1';
    }
  }

  /* ===================== aviso inline ===================== */
  function aviso(msg){
    const it = item(F(ID_ALTURA)); if(!it) return;
    let m = it.querySelector('.alt-aviso');
    if(!m){ m = document.createElement('div'); m.className='alt-aviso'; m.style.cssText='color:#dc2626;font-size:12px;margin-top:4px'; it.appendChild(m); }
    m.textContent = msg;
  }
  function limpiarAviso(){ const it=item(F(ID_ALTURA)); const m=it&&it.querySelector('.alt-aviso'); if(m) m.textContent=''; }

  /* ===================== distribución ===================== */
  function distribuir(){
    const calle=F(ID_CALLE), altura=F(ID_ALTURA), piso=getPiso();
    if(!calle || !altura) return { ok:true };
    const d = aDireccionShopify(calle.value, altura.value); // {address1, address2(altura), company(piso)}
    setVal(calle, d.address1);   // address1 = nombre de calle
    setVal(altura, d.address2);  // address2 = altura (número)
    if(piso && d.company){       // company = piso/depto. No piso lo que el cliente ya escribió ahí
      const actual = piso.value.trim();
      if(!actual) setVal(piso, d.company);
      else if(actual.toLowerCase().indexOf(d.company.toLowerCase()) === -1) setVal(piso, bordes(d.company + ' ' + actual));
    }
    return { ok: !!d.address2, d };
  }

  /* ===================== eventos ===================== */
  // IMPORTANTE: NO se formatea en tiempo real. Mientras el cliente escribe, NADA se mueve.
  // La redistribución (Calle / Altura / Piso) ocurre SOLO al hacer click en "Avançar"
  // (o submit del form), para que quede todo OK recién en el momento de avanzar.

  // ¿el click fue en uno de los dos botones finales (COD o Tarjeta)?
  // El cliente suele clickear el <span> interno: closest() sube hasta el botón/anchor.
  function esBotonAvanzar(t){
    return !!(t && t.closest && t.closest(SEL_SUBMIT));
  }

  // pointerdown (captura): deja los valores limpios ANTES de que Releasit los lea
  document.addEventListener('pointerdown', function(e){
    if(esBotonAvanzar(e.target) && F(ID_ALTURA)) distribuir();
  }, true);

  // click (captura): redistribuye y frena el avance si falta la altura
  document.addEventListener('click', function(e){
    if(!esBotonAvanzar(e.target) || !F(ID_ALTURA)) return;
    const r = distribuir();
    if(!r.ok){
      e.preventDefault(); e.stopImmediatePropagation();
      aviso('Falta la altura (el número de la puerta, ej: 1840).');
      F(ID_ALTURA).focus();
    } else {
      limpiarAviso();
    }
  }, true);

  // submit nativo del form (por si "Avançar" dispara submit en vez de un click JS)
  document.addEventListener('submit', function(e){
    var f = e.target;
    if(!f || f.id !== '_rsi-cod-form-modal-form' || !F(ID_ALTURA)) return;
    const r = distribuir();
    if(!r.ok){
      e.preventDefault(); e.stopImmediatePropagation();
      aviso('Falta la altura (el número de la puerta, ej: 1840).');
      F(ID_ALTURA).focus();
    } else {
      limpiarAviso();
    }
  }, true);

  // aplicar textos cuando aparezcan los campos (el modal se monta dinámicamente)
  new MutationObserver(setTexto).observe(document.documentElement, { childList:true, subtree:true });
  setTexto();
})();
